import axiosCustom from "common/components/apiConfig";
import {
	handleNotificationAlertCatch,
	handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import { put, takeLatest } from "redux-saga/effects";

export const actionTypes = {
	select_summaries: "[select_summaries] Action",
	select_summariesLoading: "[select_summariesLoading] Action",
	select_summariesAsync: "[select_summariesAsync] Action",
};

const initialState = {
	data: [],
	size: 10,
	total: 0,
	loading: false,
};

export const select_summaries_reducer = (
	state = initialState,
	{ type, payload },
) => {
	switch (type) {
		case actionTypes.select_summaries:
			return {
				...state,
				data: payload.results,
				total: payload.total
					? payload.total > 10000
						? 10000
						: payload.total
					: 0,
			};
		case actionTypes.select_summariesLoading:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	yield put({
		type: actionTypes.select_summariesLoading,
		payload: true,
	});

	let config = {
		url: "select_request",
	};

	let data = {
		table: "stock",
		method_type: "select_summaries",
		data: payload?.data ? payload?.data : {},
		// from: payload.from ? (payload.from - 1) * payload.size : 0,
		// size: payload.size,
		// sort_by: payload.sort_by,
	};

	try {
		let res = yield axiosCustom(config, data);

		let isOk = handleNotificationAlertTrySelect(res);
		if (!isOk) return;

		yield put({
			type: actionTypes.select_summaries,
			payload: res.data.response.data,
		});
	} catch {
		handleNotificationAlertCatch();
	} finally {
		yield put({
			type: actionTypes.select_summariesLoading,
			payload: false,
		});
	}
}

export function* selectSummaries() {
	yield takeLatest(actionTypes.select_summariesAsync, handleWorker);
}
